export default {
  LIST_FETCHED: 'PROFILE_FETCHED',
  LIST_LOAD: 'PROFILE_LOAD',
  ITEM_DETAIL: 'PROFILE_DETAIL',
  BUTTON_LOAD: 'PROFILE_BUTTON_LOAD',
};
